<span tabindex="0">
    <button class="secondary-btn delete-btn xl-btn p-0 m-0" aria-label="Remove" (click)="remove()"> 
        <span class="icon-delete"
        ><img src="../../../assets/images/icon-delete.svg" /></span>Remove</button> 
</span>